import { Provider } from 'react-redux';
import './App.less';
import './assets/scss/common.scss';
import RouterPath from './Router';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import Header from './components/Header';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className='App'>
          <Header
            url={window.location.href}
            description={''}
            title={''}
            image={''}
          />
          <RouterPath />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
